import { OptionPickerComponent } from 'src/app/components/option-picker/option-picker.component';
import { RecordPreviewComponent } from 'src/app/components/record-preview/record-preview.component';
import { MatDialogModule } from '@angular/material/dialog';
import { DataTransferActionsComponent } from 'src/app/components/data-transfer-actions/data-transfer-actions.component';
import { MarketplaceIconFallbackDirective } from 'src/app/_directives/marketplace-icon-fallback.directive';
import { PageHeaderComponent } from 'src/app/components/page-header/page-header.component';
import { KtPaginationComponent } from 'src/app/components/kt-pagination/kt-pagination.component';
import { SavedViewPickerComponent } from 'src/app/components/saved-view-picker/saved-view-picker.component';
import { DialogHeaderComponent } from 'src/app/components/dialog-header/dialog-header.component';
import { CustomerDetailsComponent } from 'src/app/components/customer-details/customer-details.component';
import { ReorderControlsComponent } from 'src/app/components/reorder-controls/reorder-controls.component';
import { A11yModule } from '@angular/cdk/a11y';
import { HeaderProductSearchComponent } from 'src/app/components/header-product-search/header-product-search.component';
import { AccountMenuComponent } from 'src/app/components/account-menu/account-menu.component';
import { CsvExportDialogComponent } from 'src/app/components/csv-export-dialog/csv-export-dialog.component';
import { NoteEditorComponent } from 'src/app/components/note-editor/note-editor.component';
import { NotesDialogComponent } from 'src/app/components/notes-dialog/notes-dialog.component';
// Angular
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
// Angular Material
import {MatButtonModule} from '@angular/material/button';
import {MatNativeDateModule} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatTabsModule} from '@angular/material/tabs';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatMenuModule} from '@angular/material/menu';
// NgBootstrap
import {NgbModule, NgbPaginationModule, NgbProgressbarModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
// Translation
import {TranslateModule} from '@ngx-translate/core';
import {AsideLeftComponent} from './aside/aside-left.component';
import {BaseComponent} from './base/base.component';
import { MessageHubService } from 'src/app/_services/message-hub.service';
import { DatatableComponent } from './datatable/datatable.component';
import {HeaderComponent} from './header/header.component';
import {HeaderMobileComponent} from './header/header-mobile/header-mobile.component';
import {TopbarComponent} from './header/topbar/topbar.component';
import {MenuItem} from './menu-item/menu-item.components';
import {NoticeComponent} from './general/notice/notice.component';
import {ErrorComponent} from './general/error/error.component';
import {LoadingComponent} from './loading/loading.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {TileComponent} from './tile/tile.component';
import {ShortNumberPipe} from './short-number/short-number.pipe';
import {DateRangePicker} from './date-range-picker/date-range-picker.component';
import {StickyDirective} from 'src/app/_directives/sticky.directive';
import {FileUploadDlgComponent} from './file-upload-dlg/file-upload-dlg.component';
import {ProductsService} from 'src/app/_services/products.service';
import {Products} from 'src/app/_global/products';
import {NgxDropzoneModule} from 'ngx-dropzone';
import {FiltersComponent} from './filters/filters.component';
import {FiltersViewComponent} from './filters-view/filters-view.component';
import {PrintLabelsComponent} from '../products/print-labels/print-labels.component';
import {ReplaceLineBreaksPipe} from './replace-line-breaks/replace-line-breaks';
import {EditBoxConfigComponent} from './edit-box-config/edit-box-config.component';
import {EditGridStateComponent} from './edit-grid-state/edit-grid-state.component';
import {FiltersDropdownComponent} from './filters-dropdown/filters-dropdown.component';
import {GridPageComponent} from './grid-page/grid-page.component';
import {AddCustomerComponent} from '../settings/customers/add/add-customer.component';
import {DiscountInputComponent} from './discount-input/discount-input.component';
import {DiscountDisplayPipe} from './data-display/discount-display.pipe';
import {RangePickerComponent} from './range-picker/range-picker.component';
import {MatIconModule} from '@angular/material/icon';
import {TooltipModule} from '../../components/tooltip/tooltip.module';
import {AssignSublocationComponent} from '../../components/assign-sublocation/assign-sublocation.component';
import {PageNotFoundComponent} from './page-not-found/page-not-found.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { MonthlyPickerComponent } from '../advanced-reorder/monthly-picker/monthly-picker.component';
import { AdvancedReorderSliderComponent } from '../advanced-reorder/slider/advanced-reorder-slider.component';
import { AdvancedReorderSubsComponent } from '../advanced-reorder/subs/advanced-reorder-subs.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { PipesModule } from 'src/app/_pipes/pipes.module';
import { Datacolumn } from './datatable/datacolumn/datacolumn.component';
import { SortableHeader } from './datatable/directives/sortableHeader.directive';
import { SubRowTemplateDirective } from './datatable/directives/subRowTemplate.directive';
import { ColumnTemplateDirective } from './datatable/directives/columnTemplate.directive';
import { VisibleColumnsPipe } from './datatable/pipes/visibeColumns.pipe';
import { LookupNotFoundTemplateDirective } from './datatable/directives/lookupNotFound.directive';
import { TitleTemplateDirective } from './datatable/directives/titleTemplate.directive';
import { ColumnGridPipe } from './datatable/pipes/columnGrid.pipe';
import { IsSelectedItemPipe } from './datatable/pipes/isSelectedItem.pipe';
import { allCheckedPipe } from './datatable/pipes/allChecked.pipe';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ItemOptionsComponent } from '../advanced-reorder/item-options/item-options.component';
import { KtDatePickerModule } from 'src/app/components/kt-date-picker/kt-date-picker.module';

@NgModule({
    declarations: [
        RecordPreviewComponent,
        AsideLeftComponent,
        BaseComponent,
        SortableHeader,
        DatatableComponent,
        Datacolumn,
        SubRowTemplateDirective,
        ColumnTemplateDirective,
        VisibleColumnsPipe,
        LookupNotFoundTemplateDirective,
        TitleTemplateDirective,
        HeaderComponent,
        MenuItem,
        HeaderMobileComponent,
        TopbarComponent,
        NoticeComponent,
        ErrorComponent,
        LoadingComponent,
        TileComponent,
        ShortNumberPipe,
        DateRangePicker,
        StickyDirective,
        FileUploadDlgComponent,
        FiltersComponent,
        FiltersDropdownComponent,
        FiltersViewComponent,
        PrintLabelsComponent,
        EditBoxConfigComponent,
        EditGridStateComponent,
        GridPageComponent,
        AddCustomerComponent,
        DiscountInputComponent,
        DiscountDisplayPipe,
        RangePickerComponent,
        AssignSublocationComponent,
        PageNotFoundComponent,
        AdvancedReorderSliderComponent,
        MonthlyPickerComponent,
        ItemOptionsComponent,
		AdvancedReorderSubsComponent,
        ColumnGridPipe,
        IsSelectedItemPipe,
        allCheckedPipe,
    ],
    exports: [
        RecordPreviewComponent,
        OptionPickerComponent, DataTransferActionsComponent,
        CsvExportDialogComponent,
        AccountMenuComponent,
        HeaderProductSearchComponent,
        NoteEditorComponent,
        NotesDialogComponent,
        SavedViewPickerComponent,
        DialogHeaderComponent,
        CustomerDetailsComponent,
        ReorderControlsComponent,
        PageHeaderComponent,
        MarketplaceIconFallbackDirective,
        AsideLeftComponent,
        BaseComponent,
        DatatableComponent,
        Datacolumn,
        TileComponent,
        SubRowTemplateDirective,
        ColumnTemplateDirective,
        VisibleColumnsPipe,
        LookupNotFoundTemplateDirective,
        TitleTemplateDirective,
        LoadingComponent,
        ShortNumberPipe,
        ReplaceLineBreaksPipe,
        DateRangePicker,
        StickyDirective,
        FileUploadDlgComponent,
        FiltersComponent,
        FiltersDropdownComponent,
        FiltersViewComponent,
        EditBoxConfigComponent,
        EditGridStateComponent,
        GridPageComponent,
        DiscountInputComponent,
        DiscountDisplayPipe,
        NoticeComponent,
        RangePickerComponent,
        AssignSublocationComponent,
        PageNotFoundComponent,
        AdvancedReorderSliderComponent,
        MonthlyPickerComponent,
        ItemOptionsComponent,
		AdvancedReorderSubsComponent,
    ],
    providers: [
        ProductsService, Products, MessageHubService
    ],
    imports: [
        MatDialogModule,
        OptionPickerComponent, DataTransferActionsComponent,
        CsvExportDialogComponent,
        AccountMenuComponent,
        HeaderProductSearchComponent,
        A11yModule,
        ReplaceLineBreaksPipe,
        NoteEditorComponent,
        NotesDialogComponent,
        SavedViewPickerComponent,
        DialogHeaderComponent,
        CustomerDetailsComponent,
        ReorderControlsComponent,
        PageHeaderComponent,
        KtPaginationComponent,
        MarketplaceIconFallbackDirective,
        MatMenuModule,
        MatIconModule,
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        MatProgressBarModule,
        MatTabsModule,
        MatButtonModule,
        MatTooltipModule,
        TranslateModule.forChild(),
        NgSelectModule,
        NgbProgressbarModule,
        NgbTooltipModule,
        NgbPaginationModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatFormFieldModule,
        MatInputModule,
        DragDropModule,
        NgbModule,
        NgxDropzoneModule,
        TooltipModule,
        NgScrollbarModule,
        ScrollingModule,
        PipesModule,
        MatCheckboxModule,
        KtDatePickerModule
    ]
})
export class ThemeModule {
}
